export default function Comparator(a, b, direction, string) {
  if(!a || !b) return -1;
  if (string) {
    return a.localeCompare(b) * direction;
  }
  return (a - b) * direction;
}
